import React from 'react'

import Icon, { type SemanticIconName } from '../Icon'
import Typography from '../Typography'

import './NavCard.scss'

export type NavCardProps = {
  iconName: SemanticIconName
  label: string
  description?: string
  onClick: () => void
}

const NavCard: React.FC<NavCardProps> = ({ iconName, label, description, onClick }) => {
  return (
    <button className='nav-card' onClick={onClick} type='button'>
      <div className='nav-card__icon-tile'>
        <Icon name={iconName} className='nav-card__icon' size={20} />
      </div>
      <div className='nav-card__body'>
        <Typography variant='body1'>{label}</Typography>
        {description && (
          <Typography variant='body2' className='nav-card__description'>
            {description}
          </Typography>
        )}
      </div>
    </button>
  )
}

export default NavCard
